<template>
  <Blocks :items="content.list" :modifier="modifier" />
</template>

<script setup lang="ts">
import { type ContentParagraphsFragment } from '#graphql-operations'

export interface Props {
  content: ContentParagraphsFragment
  modifier?: string
}

withDefaults(defineProps<Props>(), {
  content: () => [],
  modifier: ''
})

</script>
